var modules_0e839d3f = {"navigation":"Navigation_module_navigation__6e63dfa7"};
import "../../../assets/esm/components/Footer/src/Navigation~DGCTZJEU.css";

export { modules_0e839d3f as default };
//# sourceMappingURL=Navigation.module.less.js.map
